import { SVGProps } from 'react'

export const LockIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20rem"
      height="28rem"
      viewBox="0 0 20 28"
      fill="none"
      {...props}
    >
      <path
        d="M16.28 11.68L16.28 7.14C16.28 3.75 13.53 1 10.14 1L9.6 1C6.21 1 3.46 3.75 3.46 7.14L3.46 11.68"
        stroke="url(#paint0_linear_3247_9209)"
        strokeWidth="1.64"
      />
      <path
        d="M19.48 21.57C19.48 24.95 16.74 27.7 13.35 27.7H6.4C3.01 27.7 0.26 24.95 0.26 21.57V11.68H19.48V21.57Z"
        fill="#D9D9D9"
      />
      <path
        d="M19.48 21.57C19.48 24.95 16.74 27.7 13.35 27.7H6.4C3.01 27.7 0.26 24.95 0.26 21.57V11.68H19.48V21.57Z"
        fill="url(#paint1_linear_3247_9209)"
      />
      <circle cx="9.87" cy="17.02" r="2.14" fill="black" />
      <rect x="8.8" y="17.02" width="2.14" height="5.34" fill="black" />
      <defs>
        <linearGradient
          id="paint0_linear_3247_9209"
          x1="4.95"
          y1="4.99"
          x2="17.32"
          y2="7.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.36" stopColor="#E7E7E7" />
          <stop offset="1" stopColor="#4F4F4F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3247_9209"
          x1="20.28"
          y1="10.3"
          x2="20.28"
          y2="29.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
